module.exports = __webpack_public_path__ + "img/Slide38.056fd304.png";